var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"modalTriggerButton",staticClass:"btn btn-primary",attrs:{"data-btn":"editOrder"},on:{"click":function($event){return _vm.$emit('editOrder')}}},[_vm._v(" "+_vm._s(_vm.$t('editOrder'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }